
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import CountriesContent from "./components/CountriesContent.vue";

export default defineComponent({
  name: "JourneysPage",
  components: {
    BreadCrumb,
    CountriesContent,
  },
});
